import { SectionBrowser, PageHeader } from 'global/LandingPage';
import { ASSET_URL } from '../constants';

function PriceAlert() {
  return (
    <>
      <PageHeader
        title="Price Alert"
        description="Dapatkan notifikasi real-time ketika harga saham kamu tercapai"
      />
      <SectionBrowser
        title="Real-Time Notification"
        image={`${ASSET_URL}Price_Alert_Blue.jpg`}
        description="Notifikasi yang dikirimkan secara real-time, sehingga tidak akan ketinggalan momentum. Dapatkan juga di smartphonemu dalam bentuk push notification."
        reverse
      />
    </>
  );
}

export default PriceAlert;
